module.exports = __webpack_public_path__ + "static/media/12x12.72fa5b20.png";